import { connect } from 'react-redux';
import { EmailPreviewSendRequest } from 'stageclip-common';

import { fetchEmailsTemplatesIds, fetchEmailTemplate, sendEmailPreview } from 'api/mails/mails.actions';
import { PreviewEmail } from './PreviewEmail';
import { PreviewEmailContainerProps } from './PreviewEmail.types';

const mapDispatchToProps = (dispatch: Function, { participantId, eventId }: PreviewEmailContainerProps) => {
  return {
    getEmailTemplate: (templateId: string) => dispatch(fetchEmailTemplate(participantId, templateId)),
    fetchEmailsTemplatesIds: () => dispatch(fetchEmailsTemplatesIds(eventId)),
    sendEmailTemplate: (emailDetails: EmailPreviewSendRequest) =>
      dispatch(sendEmailPreview(participantId, emailDetails)),
  };
};

export const PreviewEmailContainer = connect(null, mapDispatchToProps)(PreviewEmail);
